import { ArmpReviewModal } from '../features/compliance-forms/ArmpReviewModal';
import { JobComplianceModal } from '../features/compliance-forms/JobComplianceModal';
import { PhotoViewer, RecordDetailsModal, RecordPreviewModal } from '../features/records/RecordViewers';
import { RunSheetModal } from '../features/runsheets/RunSheetModal';
import { DayScheduleModal } from '../features/schedule/DayScheduleModal';
import { JobEditorModal } from '../features/schedule/JobEditorModal';
import { useUI } from '../ui/UIProvider';

/** App-wide dialogs, in stacking order: later ones render above earlier ones. */
export function ModalHost() {
  const ui = useUI();
  return (
    <>
      {ui.daySchedule && <DayScheduleModal date={ui.daySchedule.date} />}
      {ui.runSheet && <RunSheetModal tech={ui.runSheet.tech} date={ui.runSheet.date} />}
      {ui.armpReview && <ArmpReviewModal jobKey={ui.armpReview.jobKey} />}
      {ui.jobEditor && <JobEditorModal state={ui.jobEditor} />}
      {ui.compliance && <JobComplianceModal jobId={ui.compliance.jobId} type={ui.compliance.type} />}
      {ui.recordPreview && <RecordPreviewModal recordId={ui.recordPreview.recordId} />}
      {ui.recordDetails && <RecordDetailsModal recordId={ui.recordDetails.recordId} />}
      {ui.photo && <PhotoViewer src={ui.photo.src} name={ui.photo.name} />}
    </>
  );
}
